"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['itemDetail'],
  data: function data() {
    return {
      dataDisplay: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    // console.log(this.$props.id, this.$props.type)
    console.log(this.$props.itemDetail);
    (0, _customPage.moduleDetail)({
      moduleId: this.$props.itemDetail.moduleId
    }).then(function (res) {
      _this.dataDisplay = res.data.dataDisplay;
    });
  },
  methods: {}
};